import $ from 'jquery'
import { Modal } from 'bootstrap'
import {Alert} from "./functions";

const { __ } = wp.i18n

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.js-site-header')
  const headerContainerHeight = headerContainer.clientHeight

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('data-url')
})

const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
  ;[...allModals].map((modal) => {
    new Modal(modal)
  })
}


export function createCookie(name, value, days) {
  let expires;

  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  }
  else {
    expires = "";
  }

  document.cookie = escape(name) + "=" +
      escape(value) + expires + "; path=/";
}

export function readCookie(name) {
  let nameEQ = escape(name) + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return unescape(c.substring(nameEQ.length, c.length));
  }
  return null;
}

manage_home_header_search()
$(window).scroll(function() {
  manage_home_header_search()
});

$(window).resize(function() {
  manage_home_header_search()
});

function manage_home_header_search () {
  if ($(window).width() > 992) {
    var scrollTop = $(window).scrollTop();
    if (scrollTop == 0) {
      $('.js-home-site-search').fadeOut();
      $('.js-site-search-form').addClass('site-search-top');
    } else {
      $('.js-home-site-search').fadeIn();
      $('.js-site-search-form').fadeIn(0);
      $('.js-site-search-form').removeClass('site-search-top');
    }
  } else {
    $('.js-home-site-search').fadeIn();
  }
}

$('.vn-btn-tel').hover(
    function() {
      var dataNumber = $(this).data('number');
      $(this).find('.vn-a-content').html(dataNumber);
    },
    function() {
      if ( ! $(this).hasClass('clicked') ) {
        var dataContent = $(this).data('content');
        $(this).find('.vn-a-content').html(dataContent);
      }
    }
);

$('.vn-btn-tel').click(function() {
  var dataNumber = $(this).data('number');
  $(this).find('.vn-a-content').html(dataNumber);
  $(this).addClass('clicked');
});

$('.js-near-places').click(function(e) {
  var cookieLatLng = readCookie('lat_lng')

  if (cookieLatLng == null) {
    e.preventDefault()
    var self = this; // sauvegarde de la référence à `this`

    navigator.geolocation.getCurrentPosition(
        function(position) {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

          createCookie('lat_lng', latitude + ', ' + longitude, '10');
          window.location = $(self).attr('href'); // utilisation de `self` au lieu de `this`
        },
        function(error) {
          Alert('warning', __('Geolocation is disabled. Please enable it in your browser settings.'), false)
        }
    );
  }
});

const toc = $('.vn-toc')
if (toc.length) {
  const headings = $('.entry-content h2')
  if (headings.length) {
    const list = toc.find('ul')
    headings.map((index, heading) => {
      if (heading) {
        heading.id = `toc-${index}`
        list.append(`<li><a class="vn-toc-link" href="#toc-${index}">${heading.innerText}</a></li>`)
      }
    })
  }
}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top
  var elementBottom = elementTop + $(this).outerHeight()

  var viewportTop = $(window).scrollTop()
  var viewportBottom = viewportTop + $(window).height()

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

setVisibleToc()
$(window).scroll(function() {
  setVisibleToc()
});

function setVisibleToc() {
  $('.vn-toc-link').each(function() {
    var targetId = $(this).attr('href')
    var targetElement = $(targetId)

    if (targetElement.isInViewport()) {
      $(this).addClass('is-active')
    }
    else {
      $(this).removeClass('is-active')
    }
  })
}

function adjustStickyParentSize() {
  const stickyParent = document.getElementById('js-sticky-parent');
  const absoluteChild = document.getElementById('js-absolute-child');

  if ( stickyParent != null && absoluteChild != null ) {
    const childRect = absoluteChild.getBoundingClientRect();

    stickyParent.style.height = `${childRect.height}px`;
  }
}
adjustStickyParentSize();

window.addEventListener('resize', adjustStickyParentSize);

$(document).ready(function () {
  $('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault()
    window.openAxeptioCookies()
  })
});